export const de = {
  general: {
    days: 'T.',
    subscribe: 'Abonnieren',
    unlimitedSubscription: 'Unbegrenztes Abonnement',
    prolongateSubscription: 'Klicken, um das Abonnement zu verlängern',
  },
  hints: {
    chartLoadError: 'Fehler beim Laden der Diagrammdaten.',
  },
  buttons: {
    goToMain: 'Zurück zur Startseite',
  },
  generalInfo: {
    title: 'Tagesziel',
    goals: {
      loss: 'Gewichtsabnahme',
      gain: 'Gewichtszunahme',
      maintain: 'Gewicht halten',
    },
    nutrients: {
      calories: 'Kalorien',
      proteins: 'Eiweiß',
      fats: 'Fett',
      carbs: 'Kohlenhydrate',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    status: {
      remaining: '{{value}} übrig',
      exceeded: '{{value}} überschritten',
    },
    toStats: 'Statistik anzeigen',
    error: {
      target:
        'Ihr Tagesziel konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
    },
    noTarget:
      'Es wurde noch kein Tagesziel festgelegt. Sie können es über den Bot festlegen.',
  },
  graphStats: {
    title: 'Ernährungsstatistik',
    modes: {
      today: 'Heute',
      period: 'Zeitraum',
    },
    metrics: {
      calories: 'Kalorien',
      proteins: 'Eiweiß',
      fats: 'Fett',
      carbs: 'Kohlenhydrate',
    },
    compareWithYesterday: 'Mit gestern vergleichen',
    periods: {
      week: 'Woche',
      twoWeeks: '2 Wochen',
      month: 'Monat',
    },
    series: {
      today: 'Heute',
      yesterday: 'Gestern',
      target: 'Ziel',
    },
    mealTypes: {
      breakfast: 'Frühstück',
      morning_snack: 'Vormittagssnack',
      lunch: 'Mittagessen',
      afternoon_snack: 'Nachmittagssnack',
      dinner: 'Abendessen',
      evening_snack: 'Abendsnack',
      unknown: 'Sonstiges',
    },
    empty: {
      today: 'Für heute wurden noch keine Mahlzeiten erfasst.',
      period: 'Für diesen Zeitraum sind keine Daten vorhanden.',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    error: {
      meals:
        'Die Mahlzeitendaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
      target:
        'Ihr Tagesziel konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
    },
  },
  meal: {
    mealTypes: {
      breakfast: 'Frühstück',
      morning_snack: 'Vormittagssnack',
      lunch: 'Mittagessen',
      afternoon_snack: 'Nachmittagssnack',
      dinner: 'Abendessen',
      evening_snack: 'Abendsnack',
      unknown: 'Sonstiges',
    },
    nutrients: {
      proteins: 'Eiweiß',
      fats: 'Fett',
      carbs: 'Kohlenhydrate',
    },
    macroShort: {
      proteins: 'E',
      fats: 'F',
      carbs: 'KH',
    },
    units: {
      kcal: 'kcal',
      g: 'g',
    },
    edited: 'bearbeitet',
    items: {
      title: 'Zusammensetzung',
      empty: 'Diese Mahlzeit enthält keine Einträge.',
    },
    editTitle: 'Mahlzeit bearbeiten',
    form: {
      title: 'Titel',
      description: 'Beschreibung',
      type: 'Art der Mahlzeit',
      itemName: 'Bezeichnung des Eintrags',
      totals: 'Gesamt',
    },
    buttons: {
      edit: 'Mahlzeit bearbeiten',
      delete: 'Mahlzeit löschen',
      save: 'Änderungen speichern',
      cancel: 'Abbrechen',
      addItem: 'Eintrag hinzufügen',
      confirmDelete: 'Löschen',
    },
    deleteConfirm: {
      question: 'Diese Mahlzeit löschen?',
      hint: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    success: {
      update: 'Mahlzeit aktualisiert.',
      delete: 'Mahlzeit gelöscht.',
    },
    error: {
      load: 'Die Mahlzeit konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
      update:
        'Die Änderungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
      delete:
        'Die Mahlzeit konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut.',
    },
  },
  mealsList: {
    title: 'Mahlzeiten',
    today: 'Heute',
    pickDate: 'Datum auswählen',
    weekdays: {
      0: 'So',
      1: 'Mo',
      2: 'Di',
      3: 'Mi',
      4: 'Do',
      5: 'Fr',
      6: 'Sa',
    },
    mealTypes: {
      breakfast: 'Frühstück',
      morning_snack: 'Vormittagssnack',
      lunch: 'Mittagessen',
      afternoon_snack: 'Nachmittagssnack',
      dinner: 'Abendessen',
      evening_snack: 'Abendsnack',
      unknown: 'Mahlzeit',
    },
    macroShort: {
      proteins: 'E',
      fats: 'F',
      carbs: 'KH',
    },
    units: {
      kcal: 'kcal',
    },
    total: 'Gesamt',
    empty: 'Für diesen Tag wurden keine Mahlzeiten erfasst.',
    error: {
      meals:
        'Die Mahlzeitendaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
    },
  },
}
